module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_12.ecd6cc82.png";